import React from "react"
import { cn } from "../../lib/utils"

const badgeVariants = {
  variant: {
    default: "border-transparent bg-colors-blue-600 text-white",
    secondary: "border-transparent bg-neutral-gray100 text-neutral-gray900",
    destructive: "border-transparent bg-colors-red-600 text-white",
    outline: "text-neutral-gray900",
    success: "border-transparent bg-colors-green-500 text-white",
    warning: "border-transparent bg-colors-yellow-500 text-white",
  },
}

function Badge({ className, variant = "default", ...props }) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-colors-blue-600 focus:ring-offset-2",
        badgeVariants.variant[variant],
        className
      )}
      {...props}
    />
  )
}

export { Badge, badgeVariants }